export default "__VITE_ASSET__CFt28Buz__"